'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportsController = function () {
  function ReportsController(authService, reportingService, loadingService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ReportsController);
    if (!authService.isLoggedIn()) {
      return;
    };

    this.authService = authService;
    this.reportingService = reportingService;
    this.loadingService = loadingService;

    this.availableReports = [];
    this.loadReports();
  }

  (0, _createClass3.default)(ReportsController, [{
    key: 'loadReports',
    value: function loadReports() {
      var _this = this;

      this.loadingService.showLoading('reports', 'Loading Reports ...');

      this.reportingService.availableReportsByCategory(this.authService.authData.currentLocation.key, this.authService.getRole().roleId).then(function (response) {
        _this.availableReports = (0, _lodash.groupBy)(response.data, function (o) {
          return o.categoryName;
        });
      }).catch(function (err) {}).finally(function () {
        _this.loadingService.hideLoading('reports');
      });
    }
  }]);
  return ReportsController;
}();

exports.default = ReportsController;


// WEBPACK FOOTER //
// ./client/app/components/reports/reports.controller.js